let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("eZlSX"), load("loS2s")]).then(() => parcelRequire('f5jWz'));